import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState, authAdapter } from './auth.reducer';

// Lookup the 'Auth' feature state managed by NgRx
export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

const { selectAll, selectEntities } = authAdapter.getSelectors();

export const getAuthLoading = createSelector(
  getAuthState,
  (state: AuthState) => state.loading
);

export const getAllAuth = createSelector(getAuthState, (state: AuthState) =>
  selectAll(state)
);

export const getAuthEntities = createSelector(
  getAuthState,
  (state: AuthState) => selectEntities(state)
);

export const getAuthLoggedIn = createSelector(
  getAuthState,
  (state: AuthState) => state.loggedIn
);

export const getAuthToken = createSelector(
  getAuthState,
  (state: AuthState) => state.token
);

export const getAuthUser = createSelector(
  getAuthState,
  (state: AuthState) => state.user
);

export const getAuthError = createSelector(
  getAuthState,
  (state: AuthState) => state.error
);
